var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalBallot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.68,22H6.33A4.34,4.34,0,0,1,2,17.68V6.33A4.33,4.33,0,0,1,6.33,2H17.68A4.34,4.34,0,0,1,22,6.33V17.67A4.34,4.34,0,0,1,17.68,22M6.33,4.08A2.27,2.27,0,0,0,4.08,6.33V17.67a2.27,2.27,0,0,0,2.25,2.25H17.68a2.26,2.26,0,0,0,2.24-2.25V6.33a2.26,2.26,0,0,0-2.24-2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08,10.44a.64.64,0,0,1-.44-.17L6.07,8.76a.62.62,0,1,1,.86-.9h0L8.06,8.94l3-3a.62.62,0,1,1,.94.82l-.06.06L8.52,10.26a.62.62,0,0,1-.44.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,8.7H14.12a.63.63,0,1,1,0-1.25H17.5a.63.63,0,0,1,0,1.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.26,18.29H7.74a1.87,1.87,0,0,1-1.86-1.87V13.91A1.86,1.86,0,0,1,7.74,12h2.52a1.87,1.87,0,0,1,1.87,1.87v2.51a1.87,1.87,0,0,1-1.87,1.86m-2.52-5a.62.62,0,0,0-.61.62v2.52a.61.61,0,0,0,.61.61h2.52a.61.61,0,0,0,.62-.61V13.91a.62.62,0,0,0-.62-.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,15.79H14.12a.63.63,0,1,1,0-1.25H17.5a.63.63,0,0,1,0,1.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalBallot);
export default __webpack_public_path__ + "static/media/legal-ballot.8a0d3919a1cfcdae81b9cff8364e2858.svg";
export { ForwardRef as ReactComponent };